"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M7 4L7 7.00005H10",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M1.5 9.50065C2.17592 10.7579 3.48023 11.6939 4.8499 12.2015C6.21956 12.7091 7.73439 12.7146 9.10796 12.2169C10.4815 11.7192 11.6187 10.7529 12.3044 9.50065C12.99 8.24837 13.1768 6.79692 12.8292 5.42073C12.4816 4.04454 11.6239 2.83899 10.4182 2.03202C9.21241 1.22504 7.74222 0.872561 6.28556 1.04123C4.8289 1.2099 3.48672 1.88802 2.51279 2.94738C1.53886 4.00674 1.00068 5.37393 1 6.79044M1.5 9.50065L1.5 13M1.5 9.50065H5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

exports.default = Icon;